export default __webpack_public_path__ + "static/media/circle_filterbubbla.20ad7127.png";